<template>
  <div class="invite">
    <div class="nav-bar" :class="language">
      <span class="back-icon" @click="handelBack"></span>
      <span class="title">{{ $t('邀请好友') }}</span>
      <span class="right-text" @click="goRulePage">{{ $t('活动规则') }}</span>
    </div>
    <div class="invite-content">
      <div class="rule-icon" @click="goRulePage"></div>
      <div class="invite-btn" @click="handleInvite">
        <Lottie src="./inviteBtnUg.json" />
      </div>
    </div>
    <InviteList
      language="ug"
      :weekRanks="weekRanks"
      :totalReward="totalReward"
      :myRanks="myRanks"
    />
    <div class="invite-content invite-content-zh">
      <div class="rule-icon" @click="goRulePage"></div>
      <div class="invite-btn" @click="handleInvite">
        <Lottie src="./inviteBtn.json" />
      </div>
    </div>
    <InviteList
      :weekRanks="weekRanks"
      :totalReward="totalReward"
      :myRanks="myRanks"
    />

    <van-popup
      v-model="inviteRule"
      class="rulePopup"
      :close-on-click-overlay="false"
    >
      <div class="rulePopup_title">{{ $t('活动规则') }}</div>
      <div class="rulePopup_content">
        <p>{{ $t('1、分享给好友:') }}</p>
        <p class="bp-10">
          {{ $t('若好友为新用户,注册后邀请者可获得最高188钻石奖励;') }}
        </p>
        <p class="bp-10">
          {{
            $t(
              '若好友为老用户(已注册过), 但已超过15天没有打开使用, 若好友再次打开使用，并成功充值钻石, 充值后邀请者可获得最高168钻石奖励。'
            )
          }}
        </p>
        <p class="bp-10">
          {{ $t('2、每成功邀请1名好友注册,可获得最高188钻石奖励。') }}
        </p>
        <p class="bp-10">
          {{
            $t(
              '3、每成功邀请1名回流用户或者新用户并成功充值,可获得最高168钻石奖励。回流用户为: 超过2天未打开使用app用户, 新用户未全新设备和手机号注册的用户。'
            )
          }}
        </p>
        <p class="bp-10">{{ $t('4、奖励钻石自动到账。') }}</p>
        <p>{{ $t('5、注意事项:') }}</p>
        <p class="bp-10">
          <span style="color: red">*</span>
          {{
            $t(
              '活动期间的中止、停止及续展由平台自行决定，活动停止后，新的邀请将不再享有邀请奖励;'
            )
          }}
        </p>
        <p class="bp-10">
          <span style="color: red">*</span>
          {{
            $t(
              '若邀请方存在欺诈行为，如通过买卖手机号、 个人信息 等方式邀请，通过非法渠道和方法、脚本等方式获取邀请奖励，平台有权按照无效邀请处理的同时，违规方将遭到平台封禁处罚'
            )
          }}
        </p>
        <p class="bp-10">
          <span style="color: red">*</span>
          {{
            $t(
              '请认真阅读并理解本规则，若您参与本次活动，均视为您已阅读并同意本规则，若您关于本活动有任何疑问，请您联系平台客服咨询。'
            )
          }}
        </p>
      </div>
      <div class="rule_sure" @click="inviteRule = false">{{ $t('确认') }}</div>
    </van-popup>
  </div>
</template>

<script>
import {
  appFunc_callExit,
  appFunc_callShareWeChatMiniProgram,
  appFunc_RegisterLoginCb,
  appFunc_senToken
} from '@/utils/bridge'
import { apiGetinviteWeekRanks, apiGetinviteMyRanks } from '@/api'
import { debounce } from '@/utils/index'
import { CommonModule } from '@/store/modules/common'
import InviteList from './InviteList.vue'
import Lottie from '@/components/Lottie.vue'
import AES from 'crypto-js/aes'
import ECB from 'crypto-js/mode-ecb'
import utf8 from 'crypto-js/enc-utf8'

export default {
  components: {
    InviteList,
    Lottie
  },
  data() {
    return {
      showRule: false,
      language: 'ug',
      weekRanks: [],
      myRanks: [],
      totalReward: 0,
      inviteRule: false
    }
  },
  async created() {
    this.setLanguage()
    this.getWeekRanks()
    await this.getToken()
    this.getMyRanks()
    appFunc_RegisterLoginCb(this.handleSucceed)
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, '', document.URL)
      window.addEventListener('popstate', this.handelBack, false)
    }
  },

  //页面销毁时，取消监听。否则其他vue路由页面也会被监听--物理返回键
  destroyed() {
    window.removeEventListener('popstate', this.handelBack, false)
  },
  methods: {
    siginUserId(userId) {
      try {
        const privateKey = 'a*ll&oi(d1ca^rd@'
        const keyBytes = utf8.parse(privateKey)
        const encrypt = AES.encrypt(`${userId}`, keyBytes, {
          mode: ECB
        })
        return encrypt.toString()
      } catch (error) {
        console.log(error)
        return ''
      }
    },
    setLanguage() {
      // 获取当前语言
      console.log('setLanguage', window.location.href)
      const data = this.$route.query.language || 'ug'
      this.language = data
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
    },
    // 微信登录回调
    handleSucceed(data) {
      console.log(data, '-----------------')
      const { tokenForJs, id } = JSON.parse(data)
      CommonModule.setToken(tokenForJs)
      CommonModule.setUserId(id)
      // 成功绑定
    },
    // 返回
    handelBack() {
      appFunc_callExit()
    },
    handelShowRule() {
      this.showRule = true
    },
    handleInvite: debounce(function() {
      console.log('-------------', CommonModule.token)
      const { aplus_queue } = window
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['lnvite_now', 'CLK']
      })
      if (!CommonModule.token) {
        CommonModule.login()
        return
      }
      const inviteCode = this.siginUserId(CommonModule.userId)
      console.log('邀请', inviteCode)

      if (inviteCode) {
        appFunc_callShareWeChatMiniProgram({
          title: ' ئېسىل قىز ئوغۇللارنىڭ ھەممىسى ئالۇدا ',
          content: ' ئېسىل قىز ئوغۇللارنىڭ ھەممىسى ئالۇدا ',
          activityPageUrl: '',
          wxMiniProgramId: 'gh_b30ad34fc5f1',
          wxMiniProgramPath: `pages/inviteShare/inviteShare?inviteCode=${inviteCode}`,
          webpageUrl: 'http://www.allosoft.top'
        })
      }
    }),
    goRulePage() {
      // this.$router.push({
      //   path: `/invite-rule?language=${this.language}`
      // })
      this.inviteRule = true
    },
    async getWeekRanks() {
      const { code, data } = await apiGetinviteWeekRanks()
      if (code === 1001) {
        this.weekRanks = data || []
      }
    },
    async getMyRanks() {
      const { code, data } = await apiGetinviteMyRanks()
      if (code === 1001) {
        this.totalReward = data.totalReward || 0
        this.myRanks = data.users || []
      }
    },
    async getToken() {
      const res = await appFunc_senToken()
      console.log(res, '/////////////')
      CommonModule.setUserId(res.id)
      CommonModule.setToken(res.tokenForJs)
      CommonModule.setUserPhone(res.mobile)
      CommonModule.setUserName(res.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.invite {
  @include bg-image('invite/pic_bg@2x');
  padding-top: 66px;
  .nav-bar {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    color: #000000;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    .back-icon {
      width: 30px;
      height: 30px;
      @include bg-image('icon_back');
      position: absolute;
      left: 4px;
      top: 8px;
    }
    .title {
      font-size: 16px;
      line-height: 44px;
    }
    .right-text {
      font-size: 14px;
      position: absolute;
      right: 12px;
      line-height: 44px;
    }
  }
  .invite-content {
    height: 496px;
    @include bg-image('invite/pic_zht@2x(1)');
    overflow: hidden;
    .rule-icon {
      width: 32px;
      height: 32px;
      @include bg-image('invite/icon_hdgz@2x');
      margin: 126px 0 0 280px;
    }
    .invite-btn {
      width: 243px;
      height: 67px;
      margin: 245px 0 0 81px;
    }
  }
  .invite-content-zh {
    height: 470px;
    @include bg-image('invite/pic_zht@2x');
    .invite-btn {
      margin-top: 245px;
    }
    .rule-icon {
      margin-top: 102px;
    }
  }
}

.rulePopup {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80vw;
  height: 80vh;
  border-radius: 20px;
  padding: 10px 20px 20px;
  box-sizing: border-box;

  .rulePopup_title {
    font-family: 'UKIJCJK';
    height: 40px;
    font-size: 18px;
    color: #333333;
    line-height: 40px;
    text-align: center;
  }

  .rulePopup_content {
    flex: 1;
    font-size: 14px;
    color: #5c5c5c;
    line-height: 21px;
    overflow-y: scroll;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    p {
      text-align: left;
    }
  }

  .content::-webkit-scrollbar {
    display: none;
  }

  .rule_sure {
    width: 150px;
    height: 40px;
    line-height: 40px;
    border-radius: 30px;
    margin-top: 10px;
    font-weight: bold;
    font-size: 18px;
    color: #f9ffff;
    letter-spacing: 1px;
    text-align: center;
    background-color: #ff5a46;
    box-shadow: 0 0 0 3px rgba(243, 242, 196, 1);
  }

  .bp-10 {
    padding-bottom: 7px;
  }
}

</style>
